import {
  FormattedInboxMessage,
  FormattedOutboxMessage,
} from '@src/main/modules/messages/ui/mailbox/model/formated-message.model';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MessageDetailModal.module.scss';

type FormattedMessage = FormattedInboxMessage | FormattedOutboxMessage;

interface MessageDetailModalProps {
  visible: boolean;
  message: FormattedMessage | null;
  onHide: () => void;
}

const MessageDetailModal: React.FC<MessageDetailModalProps> = ({ visible, message, onHide }) => {
  const { t } = useTranslation();

  if (!message) return null;

  return (
    <Dialog
      header={<div className={styles['modal-title']}>{t('messages.mailbox.detail.title')}</div>}
      visible={visible}
      onHide={onHide}
      style={{ width: '50vw' }}
      footer={
        <div className={styles['modal-footer']}>
          <Button label={t('common.close')} className={styles['close-button']} onClick={onHide} />
        </div>
      }
    >
      <div className={styles['message-details']}>
        <div className={styles['message-info']}>
          <div>
            <strong>{t('messages.mailbox.subject')}:</strong> {message.subject}
          </div>
          <div>
            <strong>{t('messages.mailbox.date')}:</strong>{' '}
            {message.sendDate ? new Date(message.sendDate).toLocaleString() : ''}
          </div>
          <div>
            <strong>{t('messages.mailbox.sentBy')}:</strong> {message.sendBy}
          </div>
          <div>
            <strong>{t('messages.mailbox.recipients')}:</strong> {message.recipients.join(', ')}
          </div>

          {'initDate' in message && message.initDate && (
            <div>
              <strong>{t('messages.mailbox.validFrom')}:</strong>{' '}
              {new Date(message.initDate).toLocaleString()}
            </div>
          )}
          {'endDate' in message && message.endDate && (
            <div>
              <strong>{t('messages.mailbox.validTo')}:</strong>{' '}
              {new Date(message.endDate).toLocaleString()}
            </div>
          )}
        </div>

        <div className={styles['message-text']}>
          <strong>{t('messages.mailbox.message')}:</strong>
          <textarea value={message.message} readOnly className={styles['message-textarea']} />
        </div>

        {'respondedFrom' in message && message.respondedFrom && (
          <div className={styles['responded-from']}>
            <h4>{t('messages.mailbox.detail.answeredMessage')}</h4>
            <div className={styles['responded-from-content']}>
              <div>
                <strong>{t('messages.mailbox.subject')}:</strong> {message.respondedFrom.subject}
              </div>
              <div>
                <strong>{t('messages.mailbox.date')}:</strong>{' '}
                {message.respondedFrom.sendDate
                  ? new Date(message.respondedFrom.sendDate).toLocaleString()
                  : ''}
              </div>
              <div>
                <strong>{t('messages.mailbox.sentBy')}:</strong> {message.respondedFrom.sendBy}
              </div>
              <div className={styles['message-text']}>
                <strong>{t('messages.mailbox.message')}:</strong>
                <textarea
                  value={message.respondedFrom.message}
                  readOnly
                  className={styles['message-textarea']}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default MessageDetailModal;
